import LocalizedStrings from 'localized-strings';

import { TeamMemberTransitionDisabledReason } from '__generated__/GQL';

const locales = new LocalizedStrings({
  en: {
    description:
      'It appears that this team member cannot switch to an other role.',
    goBack: 'Go back to the member list',
    reasonDescriptions: {
      CANNOT_SELF_EDIT:
        "It appears that you're trying to edit your own account. Please contact the support to perform this operation.",
      KYC_NOT_VALIDATED:
        'It appears that this team member has not completed his onboarding process yet therefore cannot switch to an other role.',
      PENDING_INVITATION:
        'It appears that this team member already has a pending invitation therefore cannot switch to an other role.',
      PERMISSION_TOO_LOW:
        "It appears that yout don't have the required authorizations to edit this team member.",
    } satisfies Partial<Record<TeamMemberTransitionDisabledReason, string>>,
    title: 'Cannot change team members roles',
  },
  fr: {
    description:
      "Il semble que ce membre de l'équipe ne puisse pas changer de rôle",
    goBack: "Revenir à la liste des membres d'équipe",
    reasonDescriptions: {
      CANNOT_SELF_EDIT:
        'Il semble que vous essayez de modifier votre propre compte. Merci de contacter le support pour effectuer cette opération.',
      KYC_NOT_VALIDATED:
        "Il semble que ce membre d'équipe n'a pas encore terminé son processus d'intégration et ne peut donc pas passer à un autre rôle.",
      PENDING_INVITATION:
        "Il semble que ce membre d'équipe a déjà une invitation en attente et ne peut donc pas passer à un autre rôle.",
      PERMISSION_TOO_LOW:
        "Il semble que vous ne disposez pas des autorisations requises pour modifier ce membre de l'équipe.",
    } satisfies Partial<Record<TeamMemberTransitionDisabledReason, string>>,
    title: "Impossible de modifier le rôle du membre d'équipe",
  },
} as const);

export default locales;
